import { render, staticRenderFns } from "./CombosGeneradosImportAsignacion.vue?vue&type=template&id=40646d35&scoped=true"
import script from "./CombosGeneradosImportAsignacion.vue?vue&type=script&lang=js"
export * from "./CombosGeneradosImportAsignacion.vue?vue&type=script&lang=js"
import style0 from "./CombosGeneradosImportAsignacion.vue?vue&type=style&index=0&id=40646d35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40646d35",
  null
  
)

export default component.exports